module.exports = __webpack_public_path__ + "static/media/i99.a6e9940b.png";